<template>
  <h1>
    {{ $options.name }}
  </h1>
</template>
<script>
export default {
  name: 'Register',
  data() {
    return {}
  },
}
</script>


// WEBPACK FOOTER //
// src/components/Register.vue